"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const address_1 = require("bitcoinjs-lib/src/address");
const bech32 = __importStar(require("bech32"));
const base_1 = __importDefault(require("./base"));
// Todo copy paste from bitcoin.ts. we can merge them later
class Litecoin extends base_1.default {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor({ network }) {
        super({ network });
        this.network.dustThreshold = 10000;
        this.network.dustPolicy = "FIXED";
        this.network.usesTimestampedTransaction = false;
    }
    toOutputScript(address) {
        return (0, address_1.toOutputScript)(address, this.network);
    }
    validateAddress(address) {
        // bech32 address
        if (address.substring(0, 3) === "ltc") {
            if (bech32.decodeUnsafe(address)) {
                return true;
            }
        }
        // bs58 address
        return super.validateAddress(address);
    }
}
exports.default = Litecoin;
//# sourceMappingURL=litecoin.js.map